import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Card, Row, Col, Spinner, Button, Accordion, Table } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { sendAlert } from '../../../actions/utils';
import { updateStatusAdminCompanyRequest } from '../../../requests/adminCompanies';
import { previredIndicatorsRequest } from '../../../requests/indicators';
import './style.scss';

const yesNo = value => {
  return value ? 'Sí' : 'No';
};

const CompanyInfo = props => {
  const [onRequest, setOnRequest] = useState(false);
  const dispatch = useDispatch();
  const { company, admin, isProfile } = props;
  const history = useHistory();
  const {
    attendanceManagement,
    bankAccountsAttributes,
    businessName,
    compensationFund,
    consultativeDtAccess,
    economicActivity,
    email,
    fantasyName,
    fullAddress,
    nationalIdentification,
    parsedPhone,
    peopleManagement,
    remunerations,
    safetyOrganization,
    signature,
    talentManagement,
    website,
    mutualRateBasic,
    mutualRateExtraordinary,
    adherentNumber,
    translatedWorkActivity,
    yearOfAgreement,
    emailDtNotifications,
    adjustShiftToDpwordPeriod
  } = company;

  const [activeKey, setActiveKey] = useState('companyData');
  const updateStatus = status => {
    setOnRequest(true);
    const allParams = {
      dispatch,
      params: { status },
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Empresa actualizada con éxito' }));
        history.push('/admin/companies');
      },
      callback: () => setOnRequest(false)
    };
    if (admin) updateStatusAdminCompanyRequest(company.id, allParams);
  };

  const [previredIndicators, setPreviredIndicators] = useState([]);
  const params = {};

  const fetchPreviredIndicators = () => {
    previredIndicatorsRequest({
      dispatch,
      params,
      successCallback: response => setPreviredIndicators(response.data)
    });
  };
  const initFetch = () => {
    fetchPreviredIndicators();
  };
  useEffect(initFetch, []);

  return (
    <>
      <div className="yellow-wrapper">
        <Accordion defaultActiveKey="0">
          <Card className="mt-3 ml-2 mr-2">
            <Col className={`${activeKey === 'companyData' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
              <Accordion.Toggle
                as={Col}
                eventKey="0"
                className="card-header-title"
                onClick={() => setActiveKey('companyData')}
                style={{ textAlign: 'right' }}
              >
                Datos Empresa
              </Accordion.Toggle>
            </Col>
            <Accordion.Collapse eventKey="0">
              <Card.Body className="personal-data card-body">
                <Row className="mt-3">
                  <Col xs={12} md={4}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">RUT:</span>
                      <span className={`answer ${!nationalIdentification ? 'text-grey' : ''}`}>
                        {nationalIdentification || 'No Aplica'}
                      </span>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Razón social:</span>
                      <span className={`answer ${!businessName ? 'text-grey' : ''}`}>{businessName}</span>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Nombre de fantasía:</span>
                      <span className={`answer ${!fantasyName ? 'text-grey' : ''}`}>{fantasyName}</span>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col xs={12} md={4}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Giro:</span>
                      <span className={`answer ${!economicActivity ? 'text-grey' : ''}`}>
                        {economicActivity?.label}
                      </span>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Actividad Laboral:</span>
                      <span className={`answer ${!translatedWorkActivity ? 'text-grey' : ''}`}>
                        {translatedWorkActivity}
                      </span>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Sitio web:</span>
                      <span className={`answer ${!website ? 'text-grey' : ''}`}>{website || 'No Aplica'}</span>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card className="mt-3 ml-2 mr-2">
            <Col className={`${activeKey === 'companyContact' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
              <Accordion.Toggle
                as={Col}
                eventKey="1"
                className="card-header-title"
                onClick={() => setActiveKey('companyContact')}
                style={{ textAlign: 'right' }}
              >
                Datos de Contacto
              </Accordion.Toggle>
            </Col>
            <Accordion.Collapse eventKey="1">
              <Card.Body className="personal-data card-body">
                <Row className="mt-3">
                  <Col xs={12} md={4}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Dirección:</span>
                      <span className={`answer ${!fullAddress ? 'text-grey' : ''}`}>{fullAddress || 'No Aplica'}</span>
                    </div>
                  </Col>
                  <Col xs={12} md={3}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Email:</span>
                      <span className={`answer ${!email ? 'text-grey' : ''}`}>{email || 'No Aplica'}</span>
                    </div>
                  </Col>
                  <Col xs={12} md={3}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Email Notificaciones DT:</span>
                      <span className={`answer ${!emailDtNotifications ? 'text-grey' : ''}`}>
                        {emailDtNotifications || 'No Aplica'}
                      </span>
                    </div>
                  </Col>
                  <Col xs={12} md={2}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Teléfono:</span>
                      <span className={`answer ${!parsedPhone ? 'text-grey' : ''}`}>{parsedPhone || 'No Aplica'}</span>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          {!isProfile && (
            <Card className="mt-3 ml-2 mr-2">
              <Col
                className={`${activeKey === 'companyLegalData' ? 'top-header-green' : 'top-header-light-gray'} br-5`}
              >
                <Accordion.Toggle
                  as={Col}
                  eventKey="2"
                  className="card-header-title"
                  onClick={() => setActiveKey('companyLegalData')}
                  style={{ textAlign: 'right' }}
                >
                  Datos Representante Legal
                </Accordion.Toggle>
              </Col>
              <Accordion.Collapse eventKey="2">
                <Card.Body className="personal-data card-body">
                  <Row className="mt-3">
                    <Col>
                      {company.representantsAttributes &&
                        company.representantsAttributes.map((representant, index) => (
                          <div key={`representant-${representant?.id}`}>
                            <Row>
                              <Col xs={12} md={4}>
                                <div className="d-flex flex-column mb-3">
                                  <span className="type">
                                    Identificación ({representant?.translatedIdentificationType}):
                                  </span>
                                  <span
                                    className={`answer ${!representant?.nationalIdentification ? 'text-grey' : ''}`}
                                  >
                                    {representant?.nationalIdentification || 'No Aplica'}
                                  </span>
                                </div>
                              </Col>
                              <Col xs={12} md={4}>
                                <div className="d-flex flex-column mb-3">
                                  <span className="type">Nombre y Apellido:</span>
                                  <span className={`answer ${!representant?.fullName ? 'text-grey' : ''}`}>
                                    {representant?.fullName ||
                                      `${representant?.name} ${representant?.firstLastName} ${representant?.secondLastName}` ||
                                      'No Aplica'}
                                  </span>
                                </div>
                              </Col>
                              <Col xs={12} md={4}>
                                <div className="d-flex flex-column mb-3">
                                  <span className="type">Firma:</span>
                                  <span className="answer">
                                    {representant?.imageSignature?.fileUrl ? (
                                      <img
                                        src={representant?.imageSignature.fileUrl}
                                        alt="Firma"
                                        style={{ height: '35px', objectFit: 'contain' }}
                                      />
                                    ) : (
                                      <span className="text-grey">No Aplica</span>
                                    )}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            {company.representantsAttributes.length > 1 &&
                              index !== company.representantsAttributes.length - 1 && (
                                <hr style={{ background: 'none' }} />
                              )}
                          </div>
                        ))}
                    </Col>
                  </Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          )}
          {!isProfile && (
            <Card className="mt-3 ml-2 mr-2">
              <Col className={`${activeKey === 'companyBankData' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
                <Accordion.Toggle
                  as={Col}
                  eventKey="3"
                  className="card-header-title"
                  onClick={() => setActiveKey('companyBankData')}
                  style={{ textAlign: 'right' }}
                >
                  Cuentas Bancarias
                </Accordion.Toggle>
              </Col>
              <Accordion.Collapse eventKey="3">
                <Card.Body className="personal-data card-body">
                  <Col>
                    <Table bordered striped size="sm" className="yellow-table mx-auto mt-3" style={{ width: '80%' }}>
                      <thead className="bg-light">
                        <tr>
                          <th>Banco Pago Nómina</th>
                          <th>Nº Cuenta Pago Nómina</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bankAccountsAttributes?.length > 0 ? (
                          bankAccountsAttributes.map(account => (
                            <tr key={`bank-${account?.id}`}>
                              <td>{account?.bankName}</td>
                              <td>{account?.account}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center text-muted">
                              Sin cuentas bancarias
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          )}
          {!isProfile && (
            <Card className="mt-3 ml-2 mr-2">
              <Col
                className={`${activeKey === 'companyExtraData' ? 'top-header-green' : 'top-header-light-gray'} br-5`}
              >
                <Accordion.Toggle
                  as={Col}
                  eventKey="4"
                  className="card-header-title"
                  onClick={() => setActiveKey('companyExtraData')}
                  style={{ textAlign: 'right' }}
                >
                  Otros
                </Accordion.Toggle>
              </Col>
              <Accordion.Collapse eventKey="4">
                <Card.Body className="personal-data card-body">
                  <Row className="mt-3">
                    <Col xs={12} md={3}>
                      <div className="d-flex flex-column mb-3">
                        <span className="type">Mutual:</span>
                        <span className={`answer ${!safetyOrganization?.label ? 'text-grey' : ''}`}>
                          {safetyOrganization?.label || 'No Aplica'}
                        </span>
                      </div>
                    </Col>
                    <Col xs={12} md={3}>
                      <div className="d-flex flex-column mb-3">
                        <span className="type">Tasa de Cotización Básica:</span>
                        <span className={`answer ${!mutualRateBasic ? 'text-grey' : ''}`}>
                          {mutualRateBasic || 'No Aplica'}
                        </span>
                      </div>
                    </Col>
                    <Col xs={12} md={3}>
                      <div className="d-flex flex-column mb-3">
                        <span className="type">Tasa de Cotización Adicional:</span>
                        <span className={`answer ${!mutualRateExtraordinary ? 'text-grey' : ''}`}>
                          {mutualRateExtraordinary || 'No Aplica'}
                        </span>
                      </div>
                    </Col>
                    <Col xs={12} md={3}>
                      <div className="d-flex flex-column mb-3">
                        <span className="type">Ley Sanna:</span>
                        <span className={`answer ${!previredIndicators?.sanna_law ? 'text-grey' : ''}`}>
                          {previredIndicators?.sanna_law || 'No Aplica'}
                        </span>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col xs={12} md={3}>
                      <div className="d-flex flex-column mb-3">
                        <span className="type">Caja de Compensación:</span>
                        <span className={`answer ${!compensationFund?.label ? 'text-grey' : ''}`}>
                          {compensationFund?.label || 'No Aplica'}
                        </span>
                      </div>
                    </Col>
                    <Col xs={12} md={3}>
                      <div className="d-flex flex-column mb-3">
                        <span className="type">Número de Adherente :</span>
                        <span className={`answer ${!adherentNumber ? 'text-grey' : ''}`}>
                          {adherentNumber || 'No Aplica'}
                        </span>
                      </div>
                    </Col>
                    <Col xs={12} md={3}>
                      <div className="d-flex flex-column mb-3">
                        <span className="type">¿En qué año se acogerá a las 40 horas?:</span>
                        <span className={`answer ${!yearOfAgreement ? 'text-grey' : ''}`}>
                          {yearOfAgreement || 'No Aplica'}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          )}
        </Accordion>
      </div>
      {admin && (
        <Card>
          <Card.Body>
            <Row>
              <>
                <Col xs={12} md={6}>
                  <Card.Title>Funcionalidades Permitidas</Card.Title>
                  <div className="info">
                    <span className="type">Gestión de Personas:</span>
                    <span className="line" />
                    <span className="answer"> {yesNo(peopleManagement)}</span>
                  </div>
                  <div className="info">
                    <span className="type">Firma Digital:</span>
                    <span className="line" />
                    <span className="answer"> {yesNo(signature)}</span>
                  </div>
                  <div className="info">
                    <span className="type">Control de Asistencia y Turnos:</span>
                    <span className="line" />
                    <span className="answer"> {yesNo(attendanceManagement)}</span>
                  </div>
                  <div className="info">
                    <span className="type">Remuneraciones:</span>
                    <span className="line" />
                    <span className="answer"> {yesNo(remunerations)}</span>
                  </div>
                  <div className="info">
                    <span className="type">Gestión de Talento:</span>
                    <span className="line" />
                    <span className="answer"> {yesNo(talentManagement)}</span>
                  </div>
                  <div className="info">
                    <span className="type">Acceso Consultivo DT:</span>
                    <span className="line" />
                    <span className="answer"> {yesNo(consultativeDtAccess)}</span>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <Card.Title>Ajustar turnos al periodo DPword</Card.Title>
                  <div className="info">
                    <span className="type">Ajustar turnos al periodo DPword:</span>
                    <span className="line" />
                    <span className="answer"> {yesNo(adjustShiftToDpwordPeriod)}</span>
                  </div>
                  <Card.Title className="mt-4">Exportar Empresa</Card.Title>
                  <div className="info">
                    <span className="type">Permite exportación:</span>
                    <span className="line" />
                    <span className="answer"> {yesNo(company.allowDownload)}</span>
                  </div>
                  <div className="info">
                    <span className="type">Fecha límite de descarga:</span>
                    <span className="line" />
                    <span className="answer"> {company.zipRequestEndDate}</span>
                  </div>
                  <div className="info">
                    <span className="type">Última descarga:</span>
                    <span className="line" />
                    <span className="answer"> {company.lastZipRequest}</span>
                  </div>
                </Col>
              </>
            </Row>
          </Card.Body>
        </Card>
      )}
      {admin && company.status === 'pending' && (
        <Card>
          <Card.Body>
            <Row>
              <Col xs={12} md={6}>
                <Card.Title>¿Acepta la creación de esta empresa?</Card.Title>
                <div className="info">
                  <span className="type">
                    Al aceptar la creación de esta empresa, se asignará como empleado a la persona que hizo la solicitud
                    y automaticamente se convertirá en administrador de la misma.
                  </span>
                </div>
              </Col>
              <Col sm={5} md={3}>
                <Button
                  onClick={() => updateStatus('accepted')}
                  className="w-100 mt-1 mt-md-4"
                  variant="info"
                  size="sm"
                  disabled={onRequest}
                >
                  Aceptar
                </Button>
              </Col>
              <Col sm={7} md={3}>
                <Button
                  onClick={() => updateStatus('rejected')}
                  className="w-100 mt-1 mt-md-4"
                  variant="danger"
                  size="sm"
                  disabled={onRequest}
                >
                  Rechazar
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
      {onRequest && (
        <div className="containerSpinnerLoad">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
    </>
  );
};

export default CompanyInfo;
